var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPartialyApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.631,
    height: 20.631,
    viewBox: "0 0 20.631 20.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.d,.e,.f,.g,.h,.i,.j{fill:#3d9ef9;}.a{opacity:0.2;}.b{opacity:0.8;}.c{opacity:0.1;}.d{opacity:0.7;}.e{opacity:0.6;}.f{opacity:0.65;}.h{opacity:0.4;}.i{opacity:0.9;}.j{opacity:0.3;}.k{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21881 2153)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21881 -2153)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225,3.827a.98.98,0,0,1-1-1V1a1,1,0,0,1,2,0v1.83A1,1,0,0,1,225,3.827Z",
    transform: "translate(-214.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M225,407.827a.98.98,0,0,1-1-1V405a1,1,0,0,1,2,0v1.83A.98.98,0,0,1,225,407.827Z",
    transform: "translate(-214.683 -387.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.036,34.1a1,1,0,0,1-.865-.5l-.9-1.564a1,1,0,1,1,1.73-1l.9,1.564a1.019,1.019,0,0,1-.366,1.364A1.234,1.234,0,0,1,114.036,34.1Z",
    transform: "translate(-107.481 -29.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M316.436,383.7a1,1,0,0,1-.865-.5l-.9-1.564a1,1,0,1,1,1.73-1l.9,1.564a1.019,1.019,0,0,1-.366,1.364A.939.939,0,0,1,316.436,383.7Z",
    transform: "translate(-301.462 -364.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.1,115.035a.939.939,0,0,1-.5-.133l-1.564-.9a1,1,0,1,1,1-1.73l1.564.9a1.019,1.019,0,0,1,.366,1.364A1,1,0,0,1,33.1,115.035Z",
    transform: "translate(-29.275 -107.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M382.735,317.435a.939.939,0,0,1-.5-.133l-1.6-.9a1,1,0,0,1,1-1.73l1.564.9a1.019,1.019,0,0,1,.366,1.364A.915.915,0,0,1,382.735,317.435Z",
    transform: "translate(-364.334 -301.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.828,226H1a1,1,0,0,1,0-2h1.83a.98.98,0,0,1,1,1A1,1,0,0,1,2.828,226Z",
    transform: "translate(0 -214.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M406.828,226H405a1,1,0,0,1,0-2h1.83a1,1,0,0,1,0,2Z",
    transform: "translate(-387.196 -214.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M30.738,317.435a1,1,0,0,1-.865-.5,1.019,1.019,0,0,1,.366-1.364l1.564-.9a1,1,0,1,1,1,1.73l-1.564.9A.8.8,0,0,1,30.738,317.435Z",
    transform: "translate(-28.508 -301.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M381.138,115.035a1,1,0,0,1-.865-.5,1.019,1.019,0,0,1,.366-1.364l1.564-.9a1,1,0,1,1,1,1.73l-1.564.9A.939.939,0,0,1,381.138,115.035Z",
    transform: "translate(-364.334 -107.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M113.138,383.7a.939.939,0,0,1-.5-.133,1.019,1.019,0,0,1-.366-1.364l.9-1.564a1,1,0,0,1,1.73,1L114,383.2A1,1,0,0,1,113.138,383.7Z",
    transform: "translate(-107.481 -364.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M315.538,34.1a.939.939,0,0,1-.5-.133,1.019,1.019,0,0,1-.366-1.364l.9-1.564a1,1,0,0,1,1.73,1l-.9,1.564A1.081,1.081,0,0,1,315.538,34.1Z",
    transform: "translate(-301.462 -29.275)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21886.234 -2147.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M75.387,70.331a5.055,5.055,0,1,1-5.055-5.055A5.061,5.061,0,0,1,75.387,70.331Z",
    transform: "translate(-65.276 -65.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1.82,3.747a.569.569,0,0,1-.406-.17L.168,2.31a.587.587,0,0,1,0-.823.566.566,0,0,1,.81,0l.837.849.636-.647L3.945.173a.575.575,0,0,1,.822,0,.6.6,0,0,1,0,.834L2.451,3.36l-.212.215a.572.572,0,0,1-.411.173Z",
    transform: "translate(2.582 3.228)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPartialyApproved);
export default __webpack_public_path__ + "static/media/ICO_Partialy_Approved.7100657e8c7d00c7259e17b8e9307204.svg";
export { ForwardRef as ReactComponent };